import get from 'lodash.get';
import { createSelector } from 'reselect';

const appFeatureSelector = (state: TReduxState) => state.root.features.app;

export const getAppFeatureData = createSelector(appFeatureSelector, (orders) =>
  get(orders, 'data', null)
);

export const getAppValidationStates = createSelector(
  appFeatureSelector,
  (state) => get(state, 'validationStates')
);


export const getBaseUrl = createSelector(getAppFeatureData, (app) =>
  get(app, 'baseUrl', '')
);
  
export const getNotificationVisibility = createSelector(getAppFeatureData, (app) =>
  get(app, 'notificationVisibility', true)
);
  

export const getSidebarVisible = createSelector(getAppFeatureData, (app) =>
  get(app, 'isSidebarVisible', '')
);  

export const getIsContactVisible = createSelector(getAppFeatureData, (app) =>
  get(app, 'isContactVisible', false)
);  

export const getIsSuggestedQuestionLoading = createSelector(
  getAppValidationStates,
  (validationStates) => get(validationStates, 'suggestedQuestions.isLoading', false)
);

